import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../images/snbs_logo2.png'
import Services from '../../api/Services'
/* image */
import Img1 from '../../images/instragram/1.jpg'
import Img2 from '../../images/instragram/2.jpg'
import Img3 from '../../images/instragram/3.jpg'
import Img4 from '../../images/instragram/4.jpg'
import Img5 from '../../images/instragram/5.jpg'
import Img6 from '../../images/instragram/6.jpg'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateEmail(email)) {
            setError('');
            console.log('Email is valid:', email);
        } else {
            setError('Please enter a valid email address.');
        }
    };

    const { upperContactArea = false, InstagramShow = false, NewsletterShow = true, FooterShape = true } = props

    return (
        <footer className={'' + props.hclass}>
            {/* {upperContactArea && (
                <div className="upper-contact-area">
                    <div className="container">
                        <div className="row">
                            <div className="col col-xs-12">
                                <div className="contact-grids">
                                    <div className="grid">
                                        <div className="icon">
                                            <i className="fi flaticon-location-1"></i>
                                        </div>
                                        <div className="details">
                                            <h5>Location:</h5>
                                            <p>7 Green Lake Street Crawfordsville</p>
                                        </div>
                                    </div>
                                    <div className="grid">
                                        <div className="icon">
                                            <i className="fi flaticon-email"></i>
                                        </div>
                                        <div className="details">
                                            <h5>Email:</h5>
                                            <p>snbsindustries@gmail.com</p>
                                        </div>
                                    </div>
                                    <div className="grid">
                                        <div className="icon">
                                            <i className="fi flaticon-phone-call"></i>
                                        </div>
                                        <div className="details">
                                            <h5>Phone:</h5>
                                            <p>7565 03 4859</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
            <div className="upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-4 col-md-6 col-12">
                            <div className="widget about-widget">
                                {/* <div className="logo widget-title">
                                    <img src={logo} alt='' height={"150px"}/>
                                </div> */}
                                <div className="widget-title">
                                        <h3>About Us</h3>
                                    </div>
                                    <p>SNBS Industries is a leading polymer processing company known for quality and customer commitment.</p>
                                {/* <p>Join our community and stay connected with the future of innovation.</p> */}
                                <div className="social-icons">
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-facebook"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-twitter-alt"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="ti-instagram"></i></Link></li>
                                          <li><Link onClick={ClickHandler} to="#"><i className="ti-youtube"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-2 col-md-6 col-sm-6">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Navigation</h3>
                                </div>
                                <ul>
                                     <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">About us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">Contact us</Link></li>
                                     <li><Link onClick={ClickHandler} to="#">Privacy Policy</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">Terms & Conditions</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-6">
                            <div className="widget link-widget service-link-widget">
                                <div className="widget-title">
                                    <h3>Products</h3>
                                </div>
                                {/* <ul>
                                    {Services.slice(0, 4).map((fservic, index) => (
                                        <li key={index}><Link onClick={ClickHandler} to={`/service-single/${fservic.slug}`}>{fservic.title}</Link></li>
                                    ))}
                                </ul> */}

                                 <ul>
                                     <li><Link onClick={ClickHandler} to="/tank3">Water Tank</Link></li>
                                    <li><Link onClick={ClickHandler} to="/ppFabric">PP Fabric</Link></li>
                                     <li><Link onClick={ClickHandler} to="/lenoBag">Leno Bag</Link></li>
                                    <li><Link onClick={ClickHandler} to="/wovenBag">PP Woven Bag</Link></li>       
                                     <li><Link onClick={ClickHandler} to="/corrugatedBox">Corrugated Box</Link></li>
                                </ul>
                            </div>
                        </div>
                        {NewsletterShow && (
                            <div className="col col-lg-3 col-md-6 col-12">
                                <div className="widget newsletter-widget">
                                    <div className="widget-title">
                                        <h3>Newsletter</h3>
                                    </div>
                                    <p>Join our newsletter to receive updates on technologies, process improvements, and industrial trends.</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="input-1">
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Email Address *"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                        {error && <div className="error-message" style={{ color: 'red' }}>{error}</div>}
                                        <div className="submit clearfix">
                                            <button type="submit">
                                                <i className="ti-email"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                        {InstagramShow &&
                            (
                                <div className="col col-lg-3 col-md-6 col-12">
                                    <div className="widget instagram">
                                        <div className="widget-title">
                                            <h3>Our Gallery</h3>
                                        </div>
                                        <ul className="d-flex">
                                            <li><img src={Img1}
                                                alt="" /></li>
                                            <li><img src={Img2}
                                                alt="" /></li>
                                            <li><img src={Img3}
                                                alt="" /></li>
                                            <li><img src={Img4}
                                                alt="" /></li>
                                            <li><img src={Img5}
                                                alt="" /></li>
                                            <li><img src={Img6}
                                                alt="" /></li>
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                 <div className="wpo-lower-footer">
                <div className="container ">
                    <div className="row align-items-center text-center">
                        <div className="col-lg-12 col-md-12  col-12">
                            <p className="copyright">Copyright &copy;<span>2025</span>
                                <span className="copyright-icon">|</span> All Rights Reserved with SNBS Industries.
                            </p>
                        </div>
                        
                    </div>
                </div>
            </div>
                {FooterShape && (
                    <div>
                        <div className="vector-1"></div>
                        <div className="vector-2"></div>
                        <div className="vector-3"></div>
                        <div className="vector-4"></div>
                        <div className="vector-5"></div>
                        <div className="vector-6"></div>
                        <div className="vector-7"></div>
                        <div className="vector-8"></div>
                    </div>
                )}
            </div>
           

        </footer >
    )
}

export default Footer;









